import { Box, Typography } from 'enova-frontend-components';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';

import { PublishedErrorLink } from '../registration/components/publishedErrorLink';
import { BuildingScreenTab } from '../../utils/navigation';

export const SoknadPublished: FC<{ buildingId: string }> = ({ buildingId }) => {
  const { t } = useTranslation();

  return (
    <Box>
      <Typography variant="h2">{t('registration.isPublished.heading.soknad')}</Typography>
      <PublishedErrorLink
        i18nKey={'registration.isPublished.description.soknad'}
        tab={BuildingScreenTab.DOCUMENTS}
        buildingId={buildingId}
      />
    </Box>
  );
};
